// extracted by mini-css-extract-plugin
export var activeFilterButton = "_i0-c";
export var backButton = "_i0-4";
export var backIcon = "_i0-5";
export var chevronShortcut = "_i0-6";
export var container = "_i0-1";
export var editor = "_i0-8";
export var editorWrapper = "_i0-7";
export var prefix = "_i0-2";
export var searchIcon = "_i0-3";
export var suffix = "_i0-9";
export var suffixContent = "_i0-a";
export var suffixText = "_i0-b";
export var wrapper = "_i0-0";